import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import vuetify from './plugins/vuetify';

import { createProvider } from './vue-apollo'

import AtoImg from '@/components/tools/AtoImg.vue'
import ConfirmDelete from '@/components/tools/ConfirmDelete.vue'
import TextEditDialog from '@/components/tools/TextEditDialog.vue'
import RichTextEditDialog from '@/components/tools/RichTextEditDialog.vue'

Vue.component("ato-img", AtoImg)
Vue.component("confirm-delete", ConfirmDelete)
Vue.component("text-edit-dialog", TextEditDialog)
Vue.component("rich-text-edit-dialog", RichTextEditDialog)

import Centered from '@/layouts/LayoutCentered';
import Default from '@/layouts/LayoutDefault';
Vue.component('centered-layout', Centered)
Vue.component('default-layout', Default)

Vue.use(require('vue-moment'));

import '@/styles/main.scss'

import _ from 'lodash';    

Object.defineProperty(Vue.prototype, '$_', { value: _ });

Vue.prototype.$bus = new Vue();
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  apolloProvider: createProvider(),
  render: h => h(App)
}).$mount('#app')
